'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagByAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.03848e-05 8.88109e-06C2.03848e-05 8.88109e-06 0.895451 0 2.00002 0H28C28 6.66667 28 13.3333 28 20C19.3334 20 10.6667 20 2.00002 20C0.895452 20 0 20 0 20L2.03848e-05 8.88109e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.03848e-05 13.3333H28V0L2.03848e-05 8.88109e-06V13.3333Z",
          fill: "#E54252"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V13.3333H2.03848e-05L0 20Z",
          fill: "#5CBE6B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.03848e-05 8.88109e-06L4.00002 0V3.00024L3.33352 4L4.00002 4.99976V7.00024L3.33352 8L4.00002 8.99976V11.0002L3.33352 12L4.00002 12.9998V15.0002L3.33352 16L4.00002 16.9998V20H0L2.03848e-05 8.88109e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.03848e-05 3L4.07696e-05 5L0 9L2.03848e-05 15V17L0.666687 16L2.03848e-05 15V13L0.666687 12L2.03848e-05 11L0 9L0.666687 8L2.03848e-05 7L4.07696e-05 5L0.666687 4L2.03848e-05 3Z",
          fill: "#E54252"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.666524 2L2.00002 0L3.33319 2L1.99986 4L0.666524 2ZM1.99986 8L0.666524 6L1.99986 4L3.33319 6L1.99986 8ZM1.99986 12L0.666524 10L1.99986 8L3.33319 10L1.99986 12ZM1.99986 16L3.33319 14L1.99986 12L0.666524 14L1.99986 16ZM1.99986 16L3.33319 18L2.00002 20L0.666524 18L1.99986 16Z",
          fill: "#E54252"
        }
      )
    ]
  }
);
const VpFlagByAsset = forwardRef(FlagByAsset);

export { VpFlagByAsset as default };
